import { actions } from 'data'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

const PasswordReset = () => {
  const { code: resetCode } = useParams()
  const dispatch = useDispatch()
  useEffect(() => {
    if (!resetCode) return
    dispatch(actions.forgotPassword.setResetCode(resetCode))
  }, [])
  return null
}

export default PasswordReset
